import {StudentSort} from '@esgi/core/authentication';

export class ChangeSortBy {
	constructor(public sortBy: StudentSort) {}
}